module.exports = __webpack_public_path__ + "img/side-laptop.a7196806.svg";